import React, { useCallback, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import FloatingSocialBar from './FloatingSocialBar';
import CookieConsent from './CookieConsent';
import PublicSeo from '../seo/PublicSeo';
import MatomoTracker from '../tracking/MatomoTracker';
import { useFullPageNavigation } from '../../lib/useFullPageNavigation';
import { useAppScrollEmitter } from '../../lib/useAppScrollEmitter';
const plexusAnimatedBg = `${process.env.PUBLIC_URL || ''}/img/plexus-animated.webp`;

/**
 * Estrutura do site público (espelho do AppShell em sosvor-artisan-web __root.tsx):
 * relative flex min-h-screen flex-col + main flex-1 w-full.
 */
export function PublicSiteChrome({ children }) {
  useFullPageNavigation(true);
  useAppScrollEmitter(true);
  const [cookieBannerVisible, setCookieBannerVisible] = useState(false);
  const [plexusReady, setPlexusReady] = useState(false);
  const handleCookieVisibility = useCallback((visible) => {
    setCookieBannerVisible(visible);
  }, []);

  useEffect(() => {
    const enablePlexus = () => setPlexusReady(true);
    if (typeof window.requestIdleCallback === 'function') {
      const idleId = window.requestIdleCallback(enablePlexus, { timeout: 2500 });
      return () => window.cancelIdleCallback(idleId);
    }
    const timeoutId = window.setTimeout(enablePlexus, 300);
    return () => window.clearTimeout(timeoutId);
  }, []);

  const pageBgStyle = plexusReady
    ? {
        backgroundImage: `linear-gradient(rgba(250, 251, 252, 0.68), rgba(250, 251, 252, 0.68)), url(${plexusAnimatedBg})`,
      }
    : undefined;

  return (
    <div className="font-public relative flex min-h-screen flex-col text-slate-900">
      <PublicSeo />
      <MatomoTracker />
      <div
        className="page-public-bg pointer-events-none fixed inset-0 -z-10"
        style={pageBgStyle}
        aria-hidden
      />
      <Header />
      <main className="flex-1 w-full min-w-0">{children}</main>
      <Footer />
      <FloatingSocialBar elevated={cookieBannerVisible} />
      <CookieConsent onVisibilityChange={handleCookieVisibility} />
    </div>  );
}

/** Layout de rotas com <Outlet /> */
export default function PublicLayout() {
  return (
    <PublicSiteChrome>
      <Outlet />
    </PublicSiteChrome>
  );
}
